import { useSelector } from 'react-redux'
import { UseTimeZone } from '../../../../common/hooks/useTimeZone'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { EventCell } from '../../../../common/news/EventCell'
import { Notification } from '../../../../common/notification'
import { Table } from '../../../../common/table'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { FORMAT, formatDateTime } from '../../../../helpers/datetime'
import { COMPONENTS } from '../../../../routers/constants'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import {
  selectLoading,
  selectRecentNews,
  selectRecentNewsById,
} from '../../store/slice'
import { Sentiment } from './Sentiment'
import { COLUMN_IDS } from './helper'
import classes from './index.module.scss'

export const RecentNews = () => {
  const locale = useSelector((state) => state.i18n.locale)
  const timezone = UseTimeZone()
  const { organizationId } = useSelector(selectCompanyInfo)
  const data = useSelector(selectRecentNews())
  const isLoading = useSelector(selectLoading('recentNews'))

  const onRowClick = (rowId) => {
    window.open(
      `${COMPONENTS.companyAnalysis.components.newsAndSocials.route}?organizationId=${organizationId}&newsId=${rowId}`,
      '_blank',
    )
  }

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    const title = 'companySummary.recentNews.' + key

    return {
      colId,
      title,
      isI18n: true,
      tdStyle: {
        whiteSpace: [COLUMN_IDS.HEADLINE, COLUMN_IDS.EVENT].includes(colId)
          ? ''
          : 'nowrap',
        width:
          colId === COLUMN_IDS.HEADLINE
            ? '70%'
            : colId === COLUMN_IDS.EVENT
            ? '30%'
            : '',
      },
      render: (data, { rowId }) => {
        switch (COLUMN_IDS[key]) {
          case COLUMN_IDS.SENTIMENT:
            return <Sentiment rowId={rowId} />
          case COLUMN_IDS.EVENT:
            return <EventCell val={data} />
          case COLUMN_IDS.HEADLINE:
            return (
              <TextEllipsisStaticLine
                text={data}
                isI18n={false}
                lineClamp={1}
              />
            )
          case COLUMN_IDS.PUBLICATION_DATE:
            return formatDateTime(data, FORMAT.DATE, locale, timezone)
          default:
            return data
        }
      },
    }
  })

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : !data || !data.length ? (
        <Notification />
      ) : (
        <Table
          ids={data.map((i) => i.newsId)}
          getDataFromRedux={selectRecentNewsById}
          isLoading={isLoading}
          schema={schema}
          onRowClick={onRowClick}
        />
      )}
    </Element>
  )
}
